/** Занятие ещё не началось и тренер не отмечал посещаемость */
export function isUpcomingUnmarked(attendance) {
  if (!attendance?.session?.start_datetime) return false;
  if (attendance.marked_at) return false;
  return new Date(attendance.session.start_datetime) > new Date();
}

/** Эффективный статус для отображения (не путать «не был» с будущим занятием) */
export function effectiveAttendanceStatus(attendance) {
  if (isUpcomingUnmarked(attendance)) return "expected";
  return attendance?.status || "absent";
}

export function attendanceStatusLabel(attendance) {
  const status = effectiveAttendanceStatus(attendance);
  const map = {
    present: "Был",
    absent: "Не был",
    excused: "Предупредил",
    expected: "Ожидается",
  };
  return map[status] || status;
}

export function attendanceStatusTone(attendance) {
  const status = effectiveAttendanceStatus(attendance);
  if (status === "present") return "present";
  if (status === "excused") return "excused";
  if (status === "expected") return "expected";
  return "absent";
}
